<!-- start app-realty-info -->
<div class="full_info_realty">

    <!-- <ng-container *ngIf="Info?.specialAdvertisement">
        <app-order-details [info]="{label: 'العنوان', value: Info?.title_ar || Info?.title_en}" />
    </ng-container> -->

    <app-order-details 
        *ngIf="Info?.region"
        [info]="{label: 'المنطقة', value: Info?.region?.regionName}"
    >
    </app-order-details>

    <app-order-details 
        *ngIf="Info?.city"
        [info]="{label: 'المدينة', value: Info?.city?.cityName}"
    >
    </app-order-details>

    <ng-container *ngIf="Info?.address_ar">
        <app-order-details [info]="{label: 'العنوان', value: Info?.address_ar}" />
    </ng-container>

    <!-- // area -->
    <app-order-details 
        [info]="{label: 'الحي', value: flatAreas}"
    >
    </app-order-details>

    <app-order-details 
        *ngIf="Info?.category"
        [info]="{label: 'نوع العقار الرئيسي', value: Info?.category?.categoryName}"
    >
    </app-order-details>

    <app-order-details 
        *ngIf="Info?.subCategory"
        [info]="{label: 'نوع العقار الفرعي', value: Info?.subCategory?.categoryName}"
    >
    </app-order-details>

    <!-- start contractType -->
    <app-order-details [info]="{label: 'نوع العقد', value: ContractTypeTitle}" />
    <!-- end contractType -->

    <!-- start rentType -->
    <!-- <ng-container *ngIf="this.Info?.rentType != null">
        <app-order-details [info]="{label: 'نوع التاجير', value: RentTypeTitle}" />
    </ng-container> -->
    <!-- end rentType -->

    <ng-container *ngIf="AdType === AdTypes.request">

        <!-- start Price -->
        <app-order-details [info]="{ value: Price, label: 'سعر  العقار'}"/>
        <!-- end Price -->

        <!-- start size -->
        <app-order-details [info]="{ value: Size, label: 'مساحة العقار'}" />
        <!-- end size -->

    </ng-container>
    
    <ng-container *ngIf="AdType === AdTypes.advertisement">

        <!-- start Price -->
        <ng-container *ngIf="Info?.price">
            <app-order-details [info]="{label: 'سعر العقار', value: Price}"/>
        </ng-container>
        <!-- end Price -->

        <!-- start Price -->
        <ng-container *ngIf="Info?.size">
            <app-order-details [info]="{label: 'مساحة العقار', value: Size}" />
        </ng-container>
        <!-- end Price -->

    </ng-container>
    
    <ng-container *ngIf="Info?.description_ar">
        <app-order-details [info]="{label: 'معلومات اضافية', value: Info?.description_ar}" />
    </ng-container>

    <ng-container *ngIf="Info?.bestFeature_ar">
        <app-order-details [info]="{label: 'افضل المميزات', value: Info?.bestFeature_ar}" />
    </ng-container>

    <!-- <app-order-details 
        *ngIf="Info?.contraindications"
        [info]="{label: 'موانع', value: Info?.contraindicationsDesc}"
    >
    </app-order-details>

    <app-order-details 
        *ngIf="Info?.undocumentedRights"
        [info]="{label: 'حقوق غير موثقة', value: Info?.undocumentedRightsDesc}"
    >
    </app-order-details>
    
    <app-order-details 
        *ngIf="Info?.influentialInformation"
        [info]="{label: 'المعلومات المؤثرة', value: Info?.influentialInformationDesc}"
    >
    </app-order-details>

    <app-order-details 
        *ngIf="Info?.guarantees"
        [info]="{label: 'ضمانات', value: Info?.guaranteesDesc}"
    >
    </app-order-details> -->

    <app-order-details 
        *ngIf="Info?.totalPrice"
        [info]="{label: 'اجمالي السعر', value: Info?.totalPrice?.toString()}"
    >
    </app-order-details>

    <app-order-details 
        *ngIf="Info?.startSaleDate"
        [info]="{label: 'تاريخ بداء البيع:', value: (Info?.startSaleDate | date: 'MM-dd-yyyy') || ''}"
    >
    </app-order-details>    

    <div class="d-flex flex-wrap gap-3 my-4 wrap_boxs">
        <!-- start PriceType -->
        <!-- <div class="wrap_check_box">
            <span class="checked"></span>
            <span class="checked_title">{{PriceTypeTitle}}</span>
        </div> -->
        <!-- start PriceType -->
    
        <!-- start enableInstallment -->
        <ng-container *ngIf="Info?.enableInstallment">
            <div class="wrap_check_box">
                <span class="checked"></span>
                <span class="checked_title">هل تريد التقسيط ؟</span>
            </div>    
        </ng-container>
        <!-- end enableInstallment -->
    
        <!-- start enablePhoneContact -->
        <ng-container *ngIf="Info?.enablePhoneContact">
            <div class="wrap_check_box">
                <span class="checked"></span>
                <span class="checked_title">السماح بالتواصل عبر الجوال ؟</span>
            </div>    
        </ng-container>
        <!-- end enablePhoneContact -->
         
        <!-- start hasDeposit -->
        <ng-container *ngIf="Info?.hasDeposit">
            <div class="wrap_check_box">
                <span class="checked"></span>
                <span class="checked_title">متاح دفع عربون</span>
            </div>    
        </ng-container>
        <!-- end hasDeposit -->
    </div>

    <div class="props_and_ft">

        <ng-container *ngIf="Crud == CrudType.create">
            <div class="row">
                <ng-container *ngIf=" Info?.properties?.length > 0">
                    <div class="col-12">
                        <h4 class="label_lg_bold">مواصفات العقار الرئيسية</h4>
                    </div>
                    <ng-container *ngFor="let props of Info?.properties; trackBy: trackByFn">
                        <div class="col-12 col-md-6 col-lg-4 mb-3">
                            <ng-container *ngIf="props?.type == FeaturesType.number">
                                <!-- import app-order-details -->
                                <app-order-details [info]="{
                                    label: props?.name,
                                    value: props?.value?.toString()
                                }"
                                >
                                </app-order-details>
                            </ng-container>
                            
                            <ng-container *ngIf="props?.type == FeaturesType.list">
                                <!-- import app-order-details -->
                                <app-order-details [info]="{
                                    label: props?.name,
                                    value: $any(props)?.value.name
                                }"
                                >
                                </app-order-details>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- <img appImgUrlCheck [src]="Info?.features[1]?.img" width="30" class="img-fluid" /> -->
                <ng-container *ngIf=" Info?.features?.length > 0 ;">
                    <div class="col-12">
                        <h4 class="label_lg_bold">مواصفات العقار الفرعيه</h4>
                    </div>
                    <ng-container *ngFor="let ft of Info?.features; trackBy: trackByFn">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
                            <div class="wrap_box_info">
                                <img 
                                    width="30px" 
                                    [src]="ft?.img" 
                                    [alt]="ft?.name" 
                                    loading="lazy"
                                    class="img-fluid"
                                    appImgUrlCheck
                                />
                                <span class="name d-block label_lg_normal">{{ft?.name}}</span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf=" Info?.banks?.length > 0">
                    <div class="col-12">
                        <h4 class="label_lg_bold">التمويل و البنوك</h4>
                    </div>
                    <ng-container *ngFor="let bank of Info?.banks; trackBy: trackByFn">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
                            <div class="wrap_box_info">
                                <img 
                                    width="30px" 
                                    [src]="bank?.img" 
                                    [alt]="bank?.name" 
                                    class="img-fluid" 
                                />
                                <span class="name d-block label_lg_normal">{{bank?.name}}</span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf=" Info?.services?.length > 0">
                    <div class="col-12">
                        <h4 class="label_lg_bold">خدمات مابعد البيع</h4>
                    </div>
                    <ng-container *ngFor="let s of Info?.services; trackBy: trackByFn">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
                            <div class="wrap_box_info">
                                <img 
                                    width="30px" 
                                    [src]="s?.img" 
                                    [alt]="s?.name" 
                                    class="img-fluid" 
                                />
                                <span class="name d-block label_lg_normal">{{s?.name}}</span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
    
        </ng-container>
    </div>

    <!-- // show if adsType advertisement -->
    <ng-container *ngIf="AdType == AdTypes.advertisement">

        <!-- // start othere features -->
        <div class="othere_features" *ngIf="IsHasBundledAds || isLand">
            <div class="custom_container">
                <div class="wrap">

                    <h4 class="sub_title bold text-center color_black">تفاصيل اضافية</h4>

                    <!-- // units -->
                    <ng-container *ngFor="let unit of Info?.units">
                        <ul class="list_none parent">
                            <li>
                                <span class="floor label_lg_bold">
                                    الطابق رقم
                                    {{unit?.floor}}
                                    <img src="/assets/img/arrow.svg" />
                                </span>
                                <ul class="list_none tabs">
                                    <ng-container *ngFor="let u of unit.unit">
                                        <li class="d-inline-block border_r label_lg_normal new">
                                            <span>الوحدة رقم</span>
                                            ( {{u?.unitNumber || u?.id}} )
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ul>
                    </ng-container>

                    <!-- // zones -->
                    <ng-container *ngFor="let zone of Info?.zones">
                        <ul class="list_none parent">
                            <li>
                                <span class="floor label_lg_bold">
                                    الزون رقم
                                    {{zone.name}}
                                    <img src="/assets/img/arrow.svg" />
                                </span>
                                <ul class="list_none tabs">
                                    <ng-container *ngFor="let land of zone.lands">
                                        <li class="d-inline-block border_r label_lg_normal new">
                                            <span>الارض رقم</span>
                                            ( {{land?.unitNumber || land?.id}} )
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ul>
                    </ng-container>

                    <!-- // lands -->
                    <!-- <ul class="list_none tabs text-center">
                        <ng-container *ngFor="let land of Info?.lands; trackBy: trackByFn">
                            <li class="d-inline-block border_r label_lg_normal d-inline-block normal" [ngClass]="{'new': land?.status == StatusType.N}">
                                <span>رقم الارض</span>
                                ( {{land?.unitNumber || land?.id}} )
                            </li>
                        </ng-container>
                    </ul> -->

                    <!-- // villas -->
                    <ul class="list_none tabs text-center">
                        <ng-container *ngFor="let villa of Info?.villas; trackBy: trackByFn">
                            <li class="d-inline-block border_r label_lg_normal d-inline-block normal" [ngClass]="{'new': villa?.status == StatusType.N}">
                                <span>رقم الفيلا</span>
                                ( {{villa?.unitNumber || villa?.id}} )
                            </li>
                        </ng-container>
                    </ul>

                    <!-- // building -->
                    <ul class="list_none tabs text-center">
                        <ng-container *ngFor="let building of Info?.buildings; trackBy: trackByFn">
                            <li class="d-inline-block border_r label_lg_normal d-inline-block normal" [ngClass]="{'new': building?.status == StatusType.N}">
                                <span>رقم العمارة</span>
                                ( {{building?.unitNumber || building?.id}} )
                            </li>
                        </ng-container>
                    </ul>                    
                </div>
            </div>
        </div>
        <!-- // end othere features -->        

        <!-- start bill -->
        <ng-container *ngIf="ShowBill && (UserInfo | async)?.type == UsersType.normalUser">
            <app-bill-data [billInfo]="billInfo" />
        </ng-container>
        <!-- end bill -->

    </ng-container>

    <!-- // show if component run with any add or upadte ads -->
    <ng-container *ngIf="Crud != CrudType.read">
        <ng-container *ngIf="ErrorMsg?.length > 0">
            <div class="col-12 text-center mt3">
                <ng-container *ngFor="let error of ErrorMsg">
                    <p class="invalid text_md_bold" [innerHTML]="error?.msg || ''"></p>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>    

</div>
<!-- end app-realty-info -->